import useHttp from './use-http';
import useRoute from './use-route';
import useEventTracking from './use-event-tracking';
import usePayoutAccountStore from '../../stores/payout-account';

import {
    ONBOARDING_COMPLETE_BUTTON_TEXT,
    ONBOARDING_INCOMPLETE_BUTTON_TEXT,
    STRIPE_CONNECT_RETURN_URL,
    STRIPE_CONNECT_REFRESH_URL,
    STRIPE_CONNECT_EDIT_RETURN_URL,
    SHOW_ONBOARDING_SUCCESS_MESSAGE_QUERY_PARAM,
    SHOW_ONBOARDING_INVALID_LINK_ERROR_QUERY_PARAM,
    ONBOARDING_INVALID_LINK_ERROR_MESSAGE,
    ONBOARDING_SUCCESS_MESSAGE
} from '../../app-v2/constants/payouts';
import { EVENT_NAME_PAYOUTS_STRIPE_KYC_FAILED } from '../../app-v2/constants/analytics-events';
import { message } from '@grininc/grin-ui';

const useOnboarding = () => {
    const hasStarted = () => {
        return usePayoutAccountStore().data;
    };

    const buttonLabel = (hasStarted, hasFinished) => {
        if (hasStarted && hasFinished) {
            return ONBOARDING_COMPLETE_BUTTON_TEXT;
        }

        return ONBOARDING_INCOMPLETE_BUTTON_TEXT;
    };

    const buttonType = (hasStarted, hasFinished) => {
        if (hasStarted && hasFinished) {
            return '';
        }

        return 'primary';
    };

    const createAccount = (contactId, country) => {
        const url = `/api/v1/contacts/${contactId}/payout-account?expand=external_account`;
        const { http } = useHttp();
        return http.post(url, {
            country
        });
    };

    const createLink = (contactId, type, payoutAccountCompleted = false) => {
        const url = `/api/v1/contacts/${contactId}/payout-account/${type}-link`;
        const { http } = useHttp();
        return http.post(url, {
            return_url_section: payoutAccountCompleted ? STRIPE_CONNECT_EDIT_RETURN_URL : STRIPE_CONNECT_RETURN_URL,
            refresh_url_section: STRIPE_CONNECT_REFRESH_URL
        });
    };

    const createOnboardingLink = (contactId, payoutAccountCompleted = false) => {
        return createLink(contactId, 'onboarding', payoutAccountCompleted);
    };

    const createUpdateLink = (contactId) => {
        return createLink(contactId, 'update');
    };

    const createDashboardLink = (contactId) => {
        return createLink(contactId, 'dashboard');
    };

    const checkOnboardingSuccess = (contactId) => {
        const route = useRoute().get();
        const events = useEventTracking();

        if (route.query[SHOW_ONBOARDING_SUCCESS_MESSAGE_QUERY_PARAM]) {
            useRoute().removeQueryParam(SHOW_ONBOARDING_SUCCESS_MESSAGE_QUERY_PARAM);
            return message.success(ONBOARDING_SUCCESS_MESSAGE);
        }

        if (route.query[SHOW_ONBOARDING_INVALID_LINK_ERROR_QUERY_PARAM]) {
            useRoute().removeQueryParam(SHOW_ONBOARDING_INVALID_LINK_ERROR_QUERY_PARAM);
            events.trackEvent(EVENT_NAME_PAYOUTS_STRIPE_KYC_FAILED, { contact_id: contactId });
            return message.error(ONBOARDING_INVALID_LINK_ERROR_MESSAGE);
        }
    };

    const hideOnboardingPoll = (contactId) => {
        const url = `/api/v1/contacts/${contactId}/payment-account/hide-onboarding-poll`;
        const { http } = useHttp();
        return http.patch(url);
    };

    return {
        hasStarted,
        buttonType,
        buttonLabel,
        checkOnboardingSuccess,
        createAccount,
        createOnboardingLink,
        createUpdateLink,
        createDashboardLink,
        hideOnboardingPoll,
    };
};

export default useOnboarding;
